import { Navigate } from "react-router-dom";

import { DashboardPageParams, getUrlToSettingsPage } from "src/router/urls";
import { SettingsSubpages } from "src/settings/SettingsSubpages";
import { useParamsDecode } from "src/utils/useParamsDecode";

export const SdkSettingsRedirect: React.FC = () => {
  const { orgId, wsId } = useParamsDecode<DashboardPageParams>();

  return (
    <Navigate
      replace
      to={getUrlToSettingsPage(orgId, wsId, SettingsSubpages.SdkBundles)}
    />
  );
};
